import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { toast } from "sonner";
import { Flag } from "lucide-react";
import api, { formatApiError } from "../api";
import { useT } from "../i18n";

export default function ReportDialog({ pro, open, onOpenChange }) {
  const { t } = useT();
  const [message, setMessage] = useState("");
  const [contact, setContact] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setLoading(true);
    try {
      await api.post("/reports", { pro_id: pro.id, message, reporter_contact: contact });
      toast.success(t("report.success"));
      setMessage(""); setContact("");
      onOpenChange(false);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="report-dialog" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "Manrope" }}>{t("report.title")}</DialogTitle>
          <DialogDescription>{pro.name} — {t("report.subtitle")}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="flex flex-col gap-4 mt-2">
          <textarea
            data-testid="report-message-input"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder={t("report.message")}
            required
            rows={4}
            className="w-full rounded-xl border border-[#0D4045]/15 bg-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D4045]/30"
          />
          <input
            data-testid="report-contact-input"
            value={contact}
            onChange={(e) => setContact(e.target.value)}
            placeholder={t("report.contact")}
            className="w-full min-h-[48px] rounded-xl border border-[#0D4045]/15 bg-white px-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D4045]/30"
          />
          <button type="submit" disabled={loading} data-testid="report-submit-btn"
            className="flex items-center justify-center gap-2 min-h-[48px] bg-[#0D4045] text-[#FDFBF7] font-semibold rounded-full hover:bg-[#0a3237] transition-colors duration-200 disabled:opacity-60">
            <Flag size={15} /> {loading ? "…" : t("report.submit")}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
